import React from "react";
import "./WhyCollegeMentor.scss";

import shape1 from "../../images/why-clg-mentor/shape-13-04-2.png.png";
import shape2 from "../../images/why-clg-mentor/shape-03-05-2.png.png";

export default function WhyCollegeMentor({
  animationCheckPointRef,
}: {
  animationCheckPointRef: (el: HTMLDivElement | null) => void;
}) {
  return (
    <div className="why-clg-mentor-main py-5 md:pt-16 pb-5 flex">
      <div className="w-[1360px] mx-auto align-middle flex gap-[16px] max-md:flex-col-reverse">
        <div className="clg-mentor-image-section pl-[15px] pr-[47px] pb-[40px] pt-[15px]">
          <div className="flex flex-col max-w-[511px]">
            <div className="self-start ml-4 max-md:max-w-full">
              <div className="flex gap-[30px] max-md:flex-row items-center max-md:justify-center md:items-end max-md:gap-4">
                <div className="img1 flex flex-col w-[41%] h-full md:h-[218px] max-md:w-[44%]  max-md:ml-0 ">
                  <img
                    src="
https://cdncollegementor.blob.core.windows.net/home-page/why-college-mentor/Why%20College%20Mentor_01.webp"
                    alt="Why College Mentor"
                    className="grow rounded-2xl object-cover shrink-0 max-w-full  w-full md:w-[190px] max-md:mt-8"
                  />
                  <div
                    ref={animationCheckPointRef}
                    className="badge flex justify-center items-center px-5 bg-indigo-500 h-[60px] rounded-[30px] w-[60px]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_10_8)">
                        <path
                          d="M10.7493 0C9.79883 0 8.9069 0.182291 8.07357 0.546875C7.24023 0.898438 6.51432 1.38672 5.89583 2.01172C5.27734 2.63672 4.78581 3.36588 4.42122 4.19922C4.05664 5.03255 3.87435 5.92448 3.87435 6.875C3.87435 7.82552 4.05664 8.71745 4.42122 9.55078C4.78581 10.3841 5.27734 11.1133 5.89583 11.7383C6.51432 12.3633 7.24023 12.8516 8.07357 13.2031C8.9069 13.5677 9.79883 13.75 10.7493 13.75C11.6999 13.75 12.5918 13.5677 13.4251 13.2031C14.2585 12.8516 14.9876 12.3633 15.6126 11.7383C16.2376 11.1133 16.7259 10.3841 17.0775 9.55078C17.4421 8.71745 17.6243 7.82552 17.6243 6.875C17.6243 5.9375 17.4421 5.04557 17.0775 4.19922C16.7259 3.36588 16.2376 2.63997 15.6126 2.02148C14.9876 1.40299 14.2585 0.911459 13.4251 0.546875C12.5918 0.182291 11.6999 0 10.7493 0ZM14.3626 5.89844L13.1908 7.38281L13.3079 9.33594C13.321 9.4401 13.3014 9.54102 13.2493 9.63867C13.1973 9.73633 13.1322 9.81771 13.054 9.88281C13.002 9.92188 12.9434 9.95117 12.8783 9.9707C12.8132 9.99023 12.748 10 12.6829 10C12.6439 10 12.6048 9.99675 12.5658 9.99023C12.5267 9.98372 12.4876 9.97396 12.4486 9.96094L10.7493 9.23828L9.06966 9.94141C8.96549 9.99349 8.86133 10.013 8.75716 10C8.65299 9.98698 8.55534 9.94792 8.46419 9.88281C8.37305 9.81771 8.30469 9.73633 8.25911 9.63867C8.21354 9.54102 8.19727 9.4401 8.21029 9.33594L8.32747 7.38281L7.13607 5.89844C7.07096 5.82031 7.02865 5.72917 7.00911 5.625C6.98958 5.52083 6.99935 5.41667 7.03841 5.3125C7.06445 5.20833 7.11654 5.12044 7.19466 5.04883C7.27279 4.97721 7.36393 4.92839 7.4681 4.90234L9.24544 4.43359L10.222 2.79297C10.3262 2.61068 10.502 2.51953 10.7493 2.51953C10.9967 2.51953 11.179 2.61068 11.2962 2.79297L12.2533 4.43359L14.0306 4.90234C14.1348 4.92839 14.2259 4.97721 14.304 5.04883C14.3822 5.12044 14.4342 5.20833 14.4603 5.3125C14.4993 5.41667 14.5091 5.52083 14.4896 5.625C14.4701 5.72917 14.4277 5.82031 14.3626 5.89844ZM3.7181 10.918L0.827474 15.9375C0.76237 16.0417 0.736328 16.1589 0.749349 16.2891C0.76237 16.4193 0.807943 16.5299 0.886068 16.6211C0.964193 16.7253 1.06185 16.7969 1.17904 16.8359C1.29622 16.875 1.41992 16.8815 1.55013 16.8555L5.22201 15.8594L6.17904 19.5312C6.2181 19.6484 6.28646 19.7493 6.38411 19.834C6.48177 19.9186 6.58919 19.9674 6.70638 19.9805C6.7194 19.9935 6.73242 20 6.74544 20C6.75846 20 6.77148 20 6.7845 20C6.90169 20 7.00911 19.9707 7.10677 19.9121C7.20443 19.8535 7.2793 19.7786 7.33138 19.6875L10.0658 14.9609C9.38867 14.9089 8.73763 14.7721 8.11263 14.5508C7.48763 14.3294 6.90495 14.043 6.36458 13.6914C5.82422 13.3398 5.32617 12.9297 4.87044 12.4609C4.42773 11.9922 4.04362 11.4779 3.7181 10.918ZM20.6712 15.9375L17.7806 10.9375C17.4681 11.4974 17.084 12.0117 16.6283 12.4805C16.1855 12.9492 15.694 13.3594 15.1536 13.7109C14.6133 14.0625 14.0306 14.3424 13.4056 14.5508C12.7806 14.7721 12.1296 14.9089 11.4525 14.9609L14.1673 19.6875C14.2324 19.7786 14.3138 19.8535 14.4115 19.9121C14.5091 19.9707 14.61 20 14.7142 20C14.7272 20 14.7402 20 14.7533 20C14.7663 20 14.7793 20 14.7923 20C14.9225 19.974 15.0332 19.9219 15.1243 19.8438C15.2155 19.7656 15.2806 19.6615 15.3197 19.5312L16.2962 15.8594L19.9486 16.8555C20.0788 16.8815 20.2025 16.875 20.3197 16.8359C20.4368 16.7969 20.5345 16.7318 20.6126 16.6406C20.6908 16.5365 20.7363 16.4225 20.7493 16.2988C20.7624 16.1751 20.7363 16.0547 20.6712 15.9375Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_10_8">
                          <rect
                            width="20.52"
                            height="20"
                            fill="white"
                            transform="matrix(1 0 0 -1 0.73999 20)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
                <div className="flex flex-col w-[41%] h-full md:h-[218px] max-md:w-[44%] max-md:ml-0">
                  <img
                    src="https://cdncollegementor.blob.core.windows.net/home-page/why-college-mentor/gallery02.webp"
                    alt="Gallery"
                    className="grow rounded-2xl object-cover w-full aspect-square max-md:mt-8"
                  />
                </div>
              </div>
            </div>
            <div className="img3">
              <div className="max-md:flex flex-col items-center">
                <img
                  src="/images/dream-big-copy.webp"
                  alt="Dream Big"
                  className="self-center lg:ml-[35px] rounded-2xl  mt-8  aspect-[2.08] max-w-[400px] h-[220px] max-md:max-w-full"
                />
              </div>
              <div className="total-students flex ">
                <div className="justify-center mr-[7px] items-center px-3 w-10 h-10 text-base leading-4 text-center text-white whitespace-nowrap bg-red-400 bg-opacity-50 rounded-[40px]">
                  <svg
                    className="h-[16px] w-[16px] text-white mt-[11px]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div className="flex flex-col">
                  <div className="text-xl min-max-xss:text-sm font-bold leading-4 text-orange-500">
                    25K+
                  </div>
                  <p className="mt-3 ">Total Students</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clg-mentor-content-section ">
          <div className="flex flex-col px-5 max-w-[692px] flex">
            <div className="w-full text-base font-extrabold tracking-widest text-indigo-500 max-md:max-w-full">
              Your Success, Our Mission
            </div>
            <div className="mt-1.5 w-full text-4xl font-extrabold text-slate-800 max-md:max-w-full">
              <h1>Why College Mentor ?</h1>
            </div>
            <div className="mt-1.5 w-full text-base font-medium leading-7 text-gray-500 max-md:max-w-full">
              At College Mentor, our mission is to accompany you on your journey
              from School to College, offering the essential tools, abundant
              resources, and invaluable Mentorship required to transform your
              Dreams into Degrees. We're more than a platform and your partners
              in making your College Dreams come true. Your journey from
              Application to Admission starts with College Mentor.
            </div>
            <div className="flex gap-4 self-start mt-10 max-md:flex-wrap">
              <div className="flex justify-center items-center px-3.5 bg-[#FF7BCD] h-[60px] rounded-[60px] w-[60px]">
                <img
                  src="https://cdncollegementor.blob.core.windows.net/home-page/why-college-mentor/dream.webp"
                  alt="Why Clg Mentor Dream"
                />
              </div>
              <div className="flex flex-col grow shrink-0 my-auto basis-0 w-fit max-md:max-w-full">
                <div className="text-xl font-bold text-slate-800 max-md:max-w-full">
                  Dream big, believe in yourself, and achieve greatness.{" "}
                </div>
                <div className="mt-1 text-sm font-medium leading-6 text-gray-500 max-md:max-w-full">
                  We're here to support you every step of the way.
                </div>
              </div>
            </div>
            <div className="flex gap-4 self-start mt-5 max-md:flex-wrap">
              <div className="flex justify-center items-center px-3.5 bg-[#FF7BCD] h-[60px] rounded-[60px] w-[60px]">
                <img
                  src="https://cdncollegementor.blob.core.windows.net/home-page/why-college-mentor/aim.webp"
                  alt="Why Clg Mentor Aim"
                />
              </div>
              <div className="flex flex-col grow shrink-0 my-auto basis-0 w-fit max-md:max-w-full">
                <div className="text-xl font-bold text-slate-800 max-md:max-w-full">
                  Turning Dreams into Reality
                </div>
                <div className="mt-1 text-sm font-medium leading-6 text-gray-500 max-md:max-w-full">
                  Together, we'll turn your dreams into reality by providing the
                  tools and mentorship you need.
                </div>
              </div>
            </div>
            <div className="flex gap-4 self-start mt-5 max-md:flex-wrap">
              <div className="flex justify-center items-center px-3.5 bg-[#FF7BCD] h-[60px] rounded-[60px] w-[60px]">
                <img
                  src="https://cdncollegementor.blob.core.windows.net/home-page/why-college-mentor/promise.webp"
                  alt="Why college mentor promise"
                />
              </div>
              <div className="flex flex-col grow shrink-0 basis-0 w-fit max-md:max-w-full">
                <div className="text-xl font-bold text-slate-800 max-md:max-w-full">
                  Our promise
                </div>
                <div className="mt-1 text-sm font-medium leading-6 text-gray-500 max-md:max-w-full">
                  Our commitment to be there till you get admission in Dream
                  colleges with Transparency in our processes, recommendations
                  and services
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col max-w-[48px]">
        <img
          src={shape1}
          alt="why collge mentor shape1"
          className="w-full aspect-[0.38]"
        />
        <img
          src={shape2}
          alt="why collge mentor shape2"
          className="mt-96 w-full aspect-[0.49]"
        />
      </div>
    </div>
  );
}
